import React from 'react';
import Tab from "../components/tab";
import { motion } from "framer-motion";
import { Typewriter } from "react-simple-typewriter";
import Footer from "../components/Footer";
import { useSelector, useDispatch } from 'react-redux';
import { saveEducation, dispatchEducation } from '../../../Redux/ActionCreator';

const Education4 = ({ nextStep, prevStep, setStep }) => {
  const flowLanguage = useSelector(e => e.t_lang.selected);
  const secret = useSelector(e => e.secret);
  const dispatch = useDispatch();
  const sidebar = useSelector(e => e.sidebarOpen.message);

  const handlePrev = () => {
    setStep(18);
  };
  
  const handleNextCall = () => {
    let educationData = {
      School: null,
      // Where_i_worked_location: $('[name="work_place"]').val(),
      Degree: "No Formal Education",
      Course: null,
      End_date: null,
    }    
    dispatch(saveEducation(educationData, secret));
    dispatch(dispatchEducation([educationData]));
    setStep(24);
  }

  return (
    <div className="bg-[#FAFAFA] px-4 md:px-6 lg:px-8 xl:px-10 py-8 w-full overflow-y-scroll ScrollOnly h-calc-70 flex justify-center lg:items-center">
      <div className={`${sidebar ? "sm:max-w-[65vw]" : "sm:max-w-[80vw]"} vsm:w-[90vw] gap-y-10 h-max py-10 px-6 md:px-8 md:py-8 lg:gap-0 lg:h-full bg-white flex flex-col lg:justify-between rounded-lg shadow-md`}>
        <div className="flex justify-between items-center mb-4">
          <div className="tabarea gap-x-0 items-center inline-flex flex-shrink-0 max-w-full overflow-hidden">
            <div className="vsm:hidden md:inline">
              <Tab
                label="Personal Information"
                current={false}
                completed={true}
                num="1"
              />
            </div>
            <div className="vsm:hidden md:inline">
              <Tab num="2" current={false} label="Experience" completed={true} />
            </div>
            <div className="vsm:hidden md:inline">
              <Tab num="3" current={false} label="Skills" completed={true} />
            </div>
            <Tab num="4" current={false} label="Language" completed={true} />
            <Tab num="4" current={true} label="Education" completed={false} />
            <Tab num="5" current={false} label="Professional Summary" completed={false} />
          </div>
        </div>

        <div className="mt-8 text-center">
          <p className="text-lg md:text-xl text-purple-600 font-medium notranslate" key={flowLanguage}>
            {flowLanguage == "Spanish" ? (
              "¡No hay problema! Muchos trabajos no requieren un título."
            ) : (
              "No problem! Many jobs don't require a degree."
            )}            
          </p>
          <p className="text-lg md:text-xl text-purple-600 font-medium notranslate" key={flowLanguage}>
          {flowLanguage == "Spanish" ? (
              "Continuemos."
            ) : (
              "Let's continue."
            )}
          </p>
        </div>

        {/* Navigation Buttons */}
        <div className="flex justify-center w-full">
          
              <motion.div 
                initial={{ opacity: 0, y: 30 }} 
                animate={{ opacity: 1, y: 0 }} 
                transition={{ duration: 0.8, ease: "easeOut", delay: 0.4 }}
                className="flex justify-between lg:max-w-[90%] w-full">
                  <button
                      onClick={handlePrev}
                      className="border-[#FF6633] border flex items-center gap-x-3 text-black font-medium py-4 px-8 rounded-md "
                  >
                      <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.5 8.99891L9.5 16.3789" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M1.5 9L9.5 1.62" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      <span className="notranslate" key={flowLanguage}>
                        {flowLanguage == "Spanish" ? (
                          "ANTERIOR"
                        ) : (
                          "PREVIOUS"
                        )}
                      </span>
                  </button>
                  
                  <button
                      onClick={handleNextCall}
                      className="bg-[#5843BD] flex items-center gap-x-3 text-white font-medium py-3 px-6 rounded-md"
                  >
                  <span className="notranslate" key={flowLanguage}>
                    {flowLanguage == "Spanish" ? (
                      "GUARDAR"
                    ) : (
                      "SAVE"
                    )}
                  </span>
                      <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.5 8.99891L1.5 16.3789" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M9.5 9L1.5 1.62" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                  </button>

              </motion.div>
          </div>

      </div>
    </div>
  );
};

export default Education4;
